import * as React from 'react'
import type { SVGProps } from 'react'

function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 150.61 145.92"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        style={{
          fill: 'currentColor',
        }}
      >
        <path d="M66.48,134.19H19.71c-.83,0-1.5-.67-1.5-1.5V54.27H1.5c-.65,0-1.22-.42-1.42-1.03-.2-.61.01-1.29.53-1.67L70,.29c.53-.39,1.25-.39,1.78,0l69.4,51.27c.52.38.74,1.06.53,1.67-.2.62-.78,1.03-1.42,1.03h-16.71v23.5c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-25c0-.83.67-1.5,1.5-1.5h13.66L70.89,3.37,6.05,51.27h13.66c.83,0,1.5.67,1.5,1.5v78.42h45.27c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" />
        <path d="M70.89,59.28c-6.82,0-12.37-5.55-12.37-12.37s5.55-12.37,12.37-12.37,12.37,5.55,12.37,12.37-5.55,12.37-12.37,12.37ZM70.89,37.55c-5.16,0-9.37,4.2-9.37,9.37s4.2,9.37,9.37,9.37,9.37-4.2,9.37-9.37-4.2-9.37-9.37-9.37Z" />
        <path d="M104.07,145.92c-9.56,0-19.11-2.06-28.2-6.19-.54-.24-.88-.78-.88-1.37v-17.38c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v16.4c16.86,7.36,35.31,7.36,52.17,0v-16.4c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v17.38c0,.59-.34,1.12-.88,1.37-9.09,4.12-18.65,6.19-28.2,6.19Z" />
        <path d="M104.07,122.68c-.21,0-.42-.04-.62-.13l-45.04-20.28c-.54-.24-.88-.78-.88-1.37s.35-1.13.88-1.37l45.04-20.28c.39-.18.84-.18,1.23,0l45.04,20.28c.54.24.88.78.88,1.37v18.41c0,.83-.67,1.5-1.5,1.5s-1.5-.67-1.5-1.5v-17.44l-43.54-19.6-41.39,18.63,41.39,18.63,31.54-14.2c.75-.34,1.64,0,1.98.75.34.75,0,1.64-.75,1.98l-32.16,14.47c-.2.09-.41.13-.62.13Z" />
      </g>
    </svg>
  )
}

export default Icon
